import { render, staticRenderFns } from "./EventProgram.vue?vue&type=template&id=50c42690&scoped=true&"
import script from "./EventProgram.vue?vue&type=script&lang=js&"
export * from "./EventProgram.vue?vue&type=script&lang=js&"
import style0 from "./EventProgram.vue?vue&type=style&index=0&id=50c42690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c42690",
  null
  
)

export default component.exports